import styles from "../landing-page-four.module.css";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

export const AppSection = () => {
  const benefits: Array<{
    description: string;
    icon: UIIconName;
  }> = [
    {
      description:
        "Upload GPS routes straight from activities tracked on your iPhone or Apple Watch",
      icon: "IPHONE-ACTIVITY",
    },
    {
      description:
        "Create a route from photos, perfect for long road trips or through-hikes where you've taken lots of photos",
      icon: "IPHONE-ROUTE",
    },
    {
      description:
        "Upload photos and have them automatically pinned to your map where you took them",
      icon: "IPHONE-UPLOAD",
    },
  ];

  return (
    <div className={styles.sectionContainer}>
      <h2 className={styles.sectionTitle}>NO NEED FOR GPX FILES</h2>
      <div className={styles.appSectionContent}>
        <div className={styles.appScreenshots}>
          <a
            href="https://apps.apple.com/us/app/trailart/id6753645992"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/landing-page/landing-four/app/SCREENSHOT-3.png"
              alt="TrailArt iOS App"
              className={styles.appScreenshot}
            />
          </a>
        </div>
        <div className={styles.appBenefits}>
          <p className={styles.appIntro}>
            We have an app for iPhone that makes things a lot easier
          </p>
          {benefits.map((benefit, index) => (
            <div key={index} className={styles.appBenefit}>
              <div className={styles.appBenefitIcon}>
                <UIIcon iconName={benefit.icon} variant="SELECTED" size={34} />
              </div>
              <p className={styles.appBenefitDescription}>
                {benefit.description}
              </p>
            </div>
          ))}
          <a
            href="https://apps.apple.com/us/app/trailart/id6753645992"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreBadge}
          >
            <img
              src="/landing-page/landing-four/app/appstore-qr-badge.png"
              alt="Download on the App Store"
              className={styles.appStoreBadgeImage}
            />
          </a>
        </div>
      </div>
    </div>
  );
};
